<template>
  <div class="content page-content" v-loading="loading">
    <div class="table-operate-nav">
      <ListButton :buttonObj="buttonObj" @create="handleCreate"></ListButton>
      <el-button type="text" icon="el-icon-refresh" @click="fetchData">刷新</el-button>
    </div>
    <el-row>
      <Table
        ref="table"
        border
        :props="table.props"
        :header="table.header.filter(item => item.isShow === true)"
        :data="table.data"
        :selection-type="table.selectionType"
      />
      <pagination
        v-bind:currentpage="currentPage"
        v-bind:pagesize="pageSize"
        v-bind:totalcount="totalCount"
        @handle-size-change="handleSizeChange"
        @handle-current-change="handleCurrentChange"
      ></pagination>
    </el-row>
    <!--详情-->
    <el-drawer
      :visible.sync="drawer"
      size="60%"
      :modal="false"
      :destroy-on-close="true"
      class="detail-drawer"
      :with-header="false"
    >
      <Read
        v-if="drawer"
        :mediaForm="mediaForm"
        :tabActiveName="drawerTabsActiveName"
        :showTip="showTip"
        @reload-content="handleReloadContent"
        @closeDrawer="handleCloseDrawer"
      ></Read>
    </el-drawer>
    <!-- 复制弹窗 -->
    <el-dialog class="copy-dialog" title="素材要复制几份？" :visible.sync="showCopyDialog" width="400px">
      <el-form :model="copyForm">
        <el-form-item label="" prop="copyNum" :rules="[{ required: true, message: '请填写份数' }]">
          <el-input-number v-model="copyForm.copyNum" :min="1"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showCopyDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleCopy">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Table } from '@ccprivate/admin-toolkit'
import ListButton from '@/components/ListButton'
import { debounce } from 'lodash'
import InputIconEdit from '@/components/InputIconEdit'
import Read from './MaterialManageRead'
import MediaView from '@/components/media/MediaView.vue'

export default {
  components: {
    Table,
    ListButton,
    Read
  },
  inject: ['projectOrder'],
  data() {
    return {
      showTip: true,
      drawer: false,
      detailMediaId: null,
      isMaterialPackage: false,
      drawerTabsActiveName: 'detail',
      mediaForm: {},
      loading: false,
      buttonObj: {
        title: '素材',
        permissionData: 'media:add'
      },
      dialogTableVisible: false,
      showClose: false,
      checkTableHeader: [],
      tableHeader: [],
      pageSize: 10,
      // 当前页码:pageNum
      currentPage: 1,
      totalCount: 1,
      // 查询的页码
      start: 1,
      filter: {},
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        // table的width全部需要改成min-width，并且保证自定义之后表格不乱
        header: [
          {
            label: '素材',
            align: 'left',
            prop: 'mediaName',
            fixed: 'left',
            'min-width': 380,
            isShow: true,
            'show-overflow-tooltip': false,
            render: (h, { row }) => {
              return (
                <div style="display:flex">
                  <div
                    v-loading={row.transcodeStatus !== 0}
                    element-loading-text={this.$consts.transcodeStatusText[row.transcodeStatus]}
                    element-loading-spinner="icon-empty"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    style="width:80px"
                  >
                    <MediaView
                      width="80px"
                      height="50px"
                      mediaClassId={row.mediaClassId}
                      src={row.mediaIcon}
                      previewSrc={row.mp4Url}
                    ></MediaView>
                  </div>
                  <div>
                    <el-tooltip content={row.mediaName} placement="top">
                      <div class="cell-content-grid">{row.mediaName}</div>
                    </el-tooltip>
                    <div style="padding:6px 0 0 12px;color:#999">ID: {row.mediaId}</div>
                  </div>
                </div>
              )
            }
          },
          {
            label: '状态',
            align: 'left',
            prop: 'checkStatus',
            'min-width': 100,
            isShow: true,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return this.$consts.materialStatisText[row.checkStatus]
            }
          },
          {
            'render-header': row => {
              return (
                <div>
                  <span>媒体方</span>
                  <el-tooltip content="审核通过/媒体方" effect="light" placement="right">
                    <i class="el-icon-question grid-tooltip-icon"></i>
                  </el-tooltip>
                </div>
              )
            },
            prop: 'approveStatus',
            align: 'center',
            'min-width': 120,
            isShow: true,
            render: (h, { row }) => {
              if (!row.mediaCableList || row.mediaCableList.length === 0) {
                return '-'
              }
              const success = row.mediaCableList.filter(item => item.checkStatus === 1)
              return (
                <span style="cursor: pointer" onClick={() => this.handleRead(row)}>
                  {success.length}/{row.mediaCableList.length}
                </span>
              )
            }
          },
          {
            'render-header': row => {
              return (
                <div>
                  <span>牌照方</span>
                  <el-tooltip content="审核通过/牌照方" effect="light" placement="right">
                    <i class="el-icon-question grid-tooltip-icon"></i>
                  </el-tooltip>
                </div>
              )
            },
            prop: 'approveStatus',
            align: 'center',
            'min-width': 120,
            isShow: true,
            render: (h, { row }) => {
              if (!row.licenseMediaList || row.licenseMediaList.length === 0) {
                return '-'
              }
              const success = row.licenseMediaList.filter(item => item.checkStatus === 1)
              return (
                <span style="cursor: pointer" onClick={() => this.handleRead(row)}>
                  {success.length}/{row.licenseMediaList.length}
                </span>
              )
            }
          },
          {
            label: '类型',
            align: 'left',
            prop: 'mediaClassId',
            'min-width': 100,
            isShow: true,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return row.adMediaClass ? row.adMediaClass.mediaClassName : ''
            }
          },
          {
            label: '时长(秒)',
            align: 'left',
            prop: 'duration',
            'min-width': 100,
            isShow: true,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              if (row.duration) {
                return row.duration
              } else {
                return '-'
              }
            }
          },
          {
            label: '广告位',
            align: 'left',
            prop: 'adSpace.spaceName',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: '广告主',
            align: 'left',
            prop: 'partnerName',
            'min-width': 150,
            isShow: this.$service.state.user.accountType === '1', // 1为代理商，广告主不显示
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return row.adDspPartner ? row.adDspPartner.partnerName : ''
            }
          },
          {
            label: '创建时间',
            align: 'left',
            prop: 'createTime',
            'min-width': 200,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: '操作栏',
            align: 'left',
            isShow: true,
            fixed: 'right',
            'min-width': 160,
            render: (h, { row }) => {
              const checkStatus = row.checkStatus
              const editDiasbled = checkStatus === 3 || checkStatus === 5
              return h('div', [
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text',
                      disabled: editDiasbled || row.transcodeStatus === 1 || row.transcodeStatus === 2
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: (event) => {
                        event.stopPropagation()
                        this.handleEdit(row)
                      }
                    },
                    directives: [
                      {
                        name: 'permission',
                        value: 'adMedia:edit'
                      }
                    ]
                  },
                  '编辑'
                ),
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: (event) => {
                        event.stopPropagation()
                        this.handleRead(row)
                      }
                    },
                    directives: [
                      {
                        name: 'permission',
                        value: 'adMedia:detail'
                      }
                    ]
                  },
                  '详情'
                ),
                h(
                  'el-dropdown',
                  {
                    props: {
                      trigger: 'click'
                    },
                    style: {
                      'margin-left': '10px'
                    },
                    on: {
                      command: (event) => {
                        this.handleCommand(row, event)
                      }
                    }
                  },
                  [
                    h('span', {
                      class: 'el-icon-more',
                      style: {
                        color: '#1890FF',
                        lineHeight: '24px',
                        cursor: 'pointer',
                        transform: 'rotate(90deg)'
                      }
                    }),
                    h(
                      'el-dropdown-menu',
                      {
                        slot: 'dropdown',
                        style: {
                          'width': '120px'
                        }
                      },
                      [
                        h(
                          'el-dropdown-item',
                          {
                            props: {
                              command: '复制',
                              disabled: row.transcodeStatus !== 0
                            },
                            directives: [
                              {
                                name: 'permission',
                                value: 'media:copy'
                              }
                            ]
                          },
                          '复制'
                        ),
                        h(
                          'el-dropdown-item',
                          {
                            props: {
                              command: '下载',
                              disabled: row.adMediaClass.mediaFormat === 'json' || row.transcodeStatus !== 0
                            },
                            directives: [
                              {
                                name: 'permission',
                                value: 'media:download'
                              }
                            ]
                          },
                          '下载'
                        ),
                        h(
                          'el-dropdown-item',
                          {
                            props: {
                              command: '删除',
                              disabled: !(
                                row.checkStatus === 0 ||
                                row.checkStatus === 3 ||
                                row.checkStatus === 5
                              ) || row.transcodeStatus === 1
                            },
                            directives: [
                              {
                                name: 'permission',
                                value: 'adMedia:operate'
                              }
                            ]
                          },
                          '删除'
                        )
                      ]
                    )
                  ]
                )
              ])
            }
          }
        ],
        data: [],
        selectionType: 'none'
      },
      showCopyDialog: false,
      copyMediaId: 0,
      copyForm: {
        copyNum: 1
      }
    }
  },
  watch: {
    'projectOrder.selectForm': {
      handler(newVal, oldVal) {
        this.currentPage = 1
        this.pageSize = 10
        this.fetchData()
      },
      deep: true
    },
    'projectOrder.searchParam'(newValue, oldValue) {
      this.currentPage = 1
      this.pageSize = 10
      this.selected = []
      this.table.selected = []
      this.selectedRow = []
    },
    'projectOrder.timeList': {
      handler() {
        this.fetchData()
      },
      deep: true
    }
  },
  methods: {
    fetchData() {
      this.loading = true
      this.filter.pageNo = this.currentPage
      this.filter.pageSize = this.pageSize
      this.filter.order = 'desc'
      this.filter.sort = 'mediaId'
      this.filter.checkStatus =
        this.projectOrder.selectForm.materialLibraryStatus !== undefined
          ? this.projectOrder.selectForm.materialLibraryStatus
          : undefined
      this.filter.spaceId = this.projectOrder.selectForm.materialLibrarySpaceId
        ? this.projectOrder.selectForm.materialLibrarySpaceId
        : undefined
      this.filter.partnerName = this.projectOrder.selectForm.materialLibraryPartnerName
        ? this.projectOrder.selectForm.materialLibraryPartnerName
        : undefined
      this.filter.duration =
        this.projectOrder.selectForm.duration !== ''
          ? parseInt(this.projectOrder.selectForm.duration)
          : undefined
      this.filter.mediaClassId =
        this.projectOrder.selectForm.materialLibraryType !== ''
          ? this.projectOrder.selectForm.materialLibraryType
          : undefined
      if (this.projectOrder.timeList) {
        this.filter.beginTime = this.$moment(this.projectOrder.timeList[0]).format(
          'YYYY-MM-DD 00:00:00'
        )
        this.filter.endTime = this.$moment(this.projectOrder.timeList[1]).format(
          'YYYY-MM-DD 23:59:59'
        )
      } else {
        this.filter.beginTime = undefined
        this.filter.endTime = undefined
      }
      this.filter.cableCheckStatus = this.projectOrder.selectForm.cableCheckStatus ? this.projectOrder.selectForm.cableCheckStatus : undefined
      this.filter.auditStatus = this.projectOrder.selectForm.auditStatus ? this.projectOrder.selectForm.auditStatus : undefined
      // if (this.projectOrder.selectNameType === 3) {
      this.filter.searchParamType = this.projectOrder.selectNameType // 素材库是3
      this.filter.searchParam = this.projectOrder.searchParam
      this.filter.transcodeStatus = this.projectOrder.selectForm.transcodeStatus
      // }
      this.$service
        .getMediaPageList(this.filter)
        .then((data) => {
          this.totalCount = data.total
          // this.table.data = []
          this.$nextTick(() => {
            this.table.data = data.rows
          })
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
        })
    },
    handleReloadContent() {
      this.fetchData()
      this.handleOpenDrawer()
    },
    handleOpenDrawer() {
      this.loading = true
      return this.$service
        .findMedia({ mediaId: this.detailMediaId })
        .then((data) => {
          if (data) {
            if (data.tipsDetail) {
              data.tipsDetail = JSON.parse(JSON.stringify(data.tipsDetail))
            }
            this.imageUrl = data.mediaIcon
            this.mediaForm = data
            this.mediaForm.isMaterialPackage = this.isMaterialPackage
            this.oldMediaForm = JSON.parse(JSON.stringify(this.mediaForm))
            this.$service.getEnableSpace().then((d) => {
              if (d.spaceList) {
                let space = d.spaceList.find(
                  (item) => item.spaceId === this.mediaForm.spaceId
                )
                if (space) {
                  if (space.adTip === 1) {
                    this.showTip = true
                  } else {
                    this.showTip = false
                  }
                }
              }
            })
            if (data.mediaDetailList && data.mediaDetailList.length > 0) {
              this.mediaForm.locationType = data.mediaDetailList[0].locationType
              this.mediaForm.coordinateX = data.mediaDetailList[0].coordinateX
              this.mediaForm.coordinateY = data.mediaDetailList[0].coordinateY
              this.mediaForm.effect = data.mediaDetailList[0].effect
              this.mediaForm.duration = data.mediaDetailList[0].duration
              this.mediaForm.landingPage = data.mediaDetailList[0].landingPage
            }
            this.loading = false
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleCloseDrawer() {
      this.drawer = false
    },
    handleCreate() {
      this.$emit('create')
    },
    handleEdit(row) {
      this.$emit('edit', row)
    },
    async handleRead(row) {
      this.detailMediaId = row.mediaId
      this.isMaterialPackage = row.adMediaClass.mediaFormat === 'json'
      await this.handleOpenDrawer()
      this.drawer = true
      this.drawerTabsActiveName = 'detail'
    },
    // 表格操作
    handleRefresh() {
      this.currentPage = 1
      this.filter = {}
      this.fetchData()
    },
    // 每页显示数据量变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchData()
    },
    handleFilterChange(type, filter) {
      if (filter) {
        this.filter = filter
      }
      if (type === 'query') {
        this.pagination.currentPage = 1
      }
      this.fetchData()
    },
    handleCommand(e, command) {
      if (command === '删除') {
        if (e.checkStatus === 0 || e.checkStatus === 3 || e.checkStatus === 5) {
          this.$confirm('确定是否删除', '提示', {
            confirmButtonText: '删除',
            cancelButtonText: '取消',
            center: true,
            showClose: false
          })
            .then(() => {
              const obj = {
                mediaIds: [e.mediaId],
                checkStatus: -1
              }
              this.$service.updateMediaStatus(obj).then((data) => {
                this.$message.success('已为您删除1条素材')
                this.fetchData()
              })
            })
            .catch(() => {})
        } else {
          this.$message.error('只有草稿、审核不通过、测试不通过的素材可以删除')
        }
      }
      if (command === '复制') {
        this.copyMediaId = e.mediaId
        this.copyForm.copyNum = 1
        this.showCopyDialog = true
      }
      if (command === '下载') {
        this.$service.downLoadImgFile({ mediaId: e.mediaId }).then((result) => {
          const a = document.createElement('a')
          a.href = result.url
          a.target = '_self'
          a.style.display = 'none'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        })
      }
    },
    handleCopy() {
      const params = {
        id: this.copyMediaId,
        quantity: this.copyForm.copyNum
      }
      this.$service.copyMaterial(params).then((data) => {
        this.$message.success('复制成功!')
        this.fetchData()
        this.showCopyDialog = false
      })
    }
  },
  created() {
    this.table.data = []
    this.fetchData()
    this.fetchDataDebounced = debounce(this.fetchData, 500)
  }
}
</script>
<style lang="stylus" scoped>
.page-content
  padding 0 16px
>>> .table-input input
  border none
  line-height 22px
  height 22px
.table-header-button
  border none !important
.el-tabs--border-card
  border none
>>> .el-tabs--border-card>.el-tabs__header
  border none
>>>.el-table-button-text
  color #1890FF
>>>.el-table-button-text.is-disabled
  color #C0C4CC
>>>.table-status
  display flex
  flex-direction row
  align-items center
>>>.el-table-text
  width calc(100% - 112px)
>>>.cell-content-grid
  width 100%
  padding-left 12px
  overflow hidden
  display -webkit-box
  display -moz-box
  text-overflow ellipsis
  -webkit-line-clamp 1
  -webkit-box-orient vertical
  white-space normal
.grid-tooltip-icon
  margin 3px 0 0 10px
  color #333
  font-size 16px
>>> .el-loading-spinner
  .icon-empty
    display block
    width 100px
    height 10px
  .el-loading-text
    line-height 16px
    font-size 12px
.table-operate-nav
  display flex
  flex-flow row nowrap
  >.el-button
    margin-left 20px
.copy-dialog >>>.el-dialog__body
  padding-bottom 0
</style>
